// extracted by mini-css-extract-plugin
export default {"no_tabledata_container":"NoTabledata_no_tabledata_container__MMFRw","no_tabledata_wrapper":"NoTabledata_no_tabledata_wrapper__GPgo4"};